"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createStyles = _interopRequireDefault(require("../utils/createStyles"));

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = ({
  spaceSize
}) => _objectSpread(_objectSpread(_objectSpread({
  stack: {
    display: 'flex'
  },
  none: {
    gap: 0
  },
  xxsmall: {
    gap: `${spaceSize.xxsmall}px`
  },
  xsmall: {
    gap: `${spaceSize.xsmall}px`
  },
  small: {
    gap: `${spaceSize.small}px`
  },
  medium: {
    gap: `${spaceSize.medium}px`
  },
  large: {
    gap: `${spaceSize.large}px`
  },
  xlarge: {
    gap: `${spaceSize.xlarge}px`
  },
  xxlarge: {
    gap: `${spaceSize.xxlarge}px`
  },
  horizontal: {
    flexDirection: 'row',
    width: 'fit-content'
  },
  fullWidth: {
    width: '100%'
  },
  fullHeight: {
    height: '100%'
  },
  vertical: {
    flexDirection: 'column'
  }
}, (0, _createStyles.default)('alignItems', _constants.ALIGN_ITEMS)), (0, _createStyles.default)('justifyContent', _constants.JUSTIFY_CONTENT)), {}, {
  /**
   * For case when we don't wrap items in a row
   * but expect that even inline items will be placed vertically
   */
  verticalWithSpaceNone: {
    display: 'flex',
    flexDirection: 'column'
  }
});

exports.default = _default;